import { IRole } from "../../interfaces/roles.interface";

export namespace RoleActions {
  export class GetRoles {
    static readonly type = '[Role] Get Roles';
    constructor(public page?: number, public pageSize?: number, public q?: string) {}
  }

  export class GetRolesSuperAdmin {
    static readonly type = '[Role] Get Roles Super Admin';
    constructor(public page?: number, public pageSize?: number) {}
  }

  export class GetRoleById {
    static readonly type = '[Role] Get Role By Id';
    constructor(public id: number) {}
  }

  export class CreateRole {
    static readonly type = '[Role] Create Role';
    constructor(public role: IRole) {}
  }

  export class UpdateRole {
    static readonly type = '[Role] Update Role';
    constructor(public id: number, public role: IRole) {}
  }

  export class DeleteRole {
    static readonly type = '[Role] Delete Role';
    constructor(public id: number) {}
  }


  export class GetSuperAdminPermissions {
    static readonly type = '[Role] Get Super Admin Permissions';
  }

  export class GetAdminPermissions {
    static readonly type = '[Role] Get Admin Permissions';
  }

  export class GetPermissionModulesLabels {
    static readonly type = '[Role] Get Permission Modules Labels';
  }

  export class GetPermissionsModules {
    static readonly type = '[Role] Get Permission Modules';
  }

  export class GetPlatformPermissions {
    static readonly type = '[Role] Get Platform Permissions';
  }
}
